import { render, staticRenderFns } from "./MerchantRejected.vue?vue&type=template&id=2d327215"
import script from "./MerchantRejected.vue?vue&type=script&lang=js"
export * from "./MerchantRejected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports